import {t} from "i18next";

const getFrequencyBySla = (sla: string): number => {
    let frequency = 180
    switch (sla || 'base') {
        case 'base':
            frequency = 180
            break

        case 'middle':
            frequency = 60
            break

        case 'increased':
            frequency = 30
            break

        case 'high':
            frequency = 10
            break
    }

    return frequency
}

export default getFrequencyBySla;
